import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { Payment, formatCurrency } from './PaymentTypes';

interface PaymentScheduleTableProps {
  paymentList: Payment[];
  selectedPaymentId: number | null;
  onSelect: (id: number) => void;
  title?: string;
}

export const PaymentScheduleTable: React.FC<PaymentScheduleTableProps> = ({
  paymentList,
  selectedPaymentId,
  onSelect,
  title = '直近の支払い予定額'
}) => {
  return (
    <Box sx={{ mt: 2, mb: 6, maxWidth: 450 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <TableContainer sx={{ maxHeight: 210 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>支払日</TableCell>
              <TableCell align="right">合計支払額</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentList.map((payment) => (
              <TableRow
                key={payment.id}
                hover
                selected={selectedPaymentId === payment.id}
                onClick={() => onSelect(payment.id)}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>
                  {typeof payment.paymentDate === 'string'
                    ? payment.paymentDate.split('T')[0]
                    : new Date(payment.paymentDate).toISOString().split('T')[0]}
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" fontWeight="bold">
                    {formatCurrency(payment.totalPaymentAmount)}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PaymentScheduleTable;
